<template>
    <div class="popup__wrap">
        <transition name="fade-popup" appear>
            <div class="popup" v-on-click-outside="cancel">
                <span class="popup__title section-title">
                    <slot name="popupTitle"></slot>
                </span>
                <div class="popup__btn-wrap">
                    <a class="btn btn--mid popup__btn" href="javascript:;" @click="cancel()">
                        <slot name="popupCancel"></slot>
                    </a>
                    <a class="btn btn--mid popup__btn" href="javascript:;" @click="confirm()">
                        <slot name="popupConfirm"></slot>
                    </a>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import { mixin as onClickOutside } from 'vue-on-click-outside';

export default {
	props: {
		data: {
			type: Object,
			required: true
		}
	},
	mixins: [onClickOutside],
	methods: {
		cancel() {
			this.$emit('closePopupDelete');
		},
		confirm() {
			this.$emit('confirmPopupDelete', this.data.itemID);
		}
	}
};
</script>

<style lang="scss" scoped>
.popup__wrap {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    z-index: 99999;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba($slate-gray, .5);
}
.popup {
    max-width: 475px;
    padding: 50px 40px;
    width: 100%;
    background-color: $white;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    box-shadow: 0 2px 4px rgba($black, .25);
    border-radius: 8px;

    @include mq($lg) {
        padding: 40px 30px;
    }

    @include mq($sm) {
        padding: 40px 15px;
    }
}

.popup__title {
    margin-bottom: 25px;
    font-size: 20px;
    text-align: center;

    @include mq($lg) {
        font-size: 18px;
        margin-bottom: 20px;
    }

    @include mq($md) {
        font-size: 16px;
    }

    @include mq($sm) {
        font-size: 15px;
    }
}

.popup__btn-wrap {
    display: flex;
    justify-content: space-between;
    align-items: center;
	padding: 0 50px;
    max-width: 100%;
    width: 100%;

    @include mq($lg) {
        padding: 0 30px;
        justify-content: space-around;
    }

    @include mq($sm) {
        padding: 0 20px;
    }
}

.popup__btn {
    @include mq(400px) {
        padding: 5px;
        max-width: 100px;
    }
}
</style>
